<template>
  <div class="login pointer">
    <div class="headBox" @click="zaixiankefu">
      <img class="logoClass" src="../../assets/logo.png" alt="" />
      <div class="fanhuiBox" @click="fanhui">
        <img class="fanhui" src="@/assets/icons/fanhui.png" alt="" />
      </div>
    </div>

    <div class="main">
      <div class="denglu">
        <div class="shoujihao">
          <span class="inputBoxName">手机号</span>
          <van-cell-group
            :class="['inputBox', jiaodian ? 'huoqujiaodian' : 'shiqujiaodian']"
          >
            <van-popover
              v-model="showPopover"
              trigger="click"
              :offset="[50, 10]"
            >
              <van-cell-group class="cellGroup">
                <van-cell
                  :title="item"
                  class="vanCell"
                  v-for="(item, index) in loginAccounts"
                  :key="index"
                  @click="recordClick(item)"
                >
                  <template #right-icon>
                    <van-icon
                      name="cross"
                      class="cross-icon"
                      @click.stop="delrecordClick(index)"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
              <template #reference>
                <van-field
                  class="inputBack"
                  v-model="phone"
                  type="tel"
                  placeholder="请输入手机号"
                  @focus="huoqu"
                  @blur="shiqu"
                  maxlength="11"
                />
              </template>
            </van-popover>
          </van-cell-group>
        </div>
        <div v-if="Switchlogin" class="yanzhengma">
          <span class="inputBoxName">验证码</span>
          <van-cell-group
            :class="['inputBox', jiaodian ? 'huoqujiaodian' : 'shiqujiaodian']"
          >
            <van-field
              class="inputBack"
              v-model="yanzhengma"
              placeholder="请输入验证码"
              @focus="huoqus"
              @blur="shiqus"
              maxlength="6"
            >
              <template #button>
                <van-button
                  v-if="!yzm_daojishi"
                  size="small"
                  class="yzm_btn"
                  @click="getyanzhengma"
                  >获取验证码</van-button
                >
                <van-button v-else size="small" class="yzm_btn" :disabled="true"
                  >重新发送（{{ countDown }}）</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
        </div>
        <div v-else class="yanzhengma">
          <span class="inputBoxName">密码登录</span>
          <van-cell-group
            :class="['inputBox', jiaodian ? 'huoqujiaodian' : 'shiqujiaodian']"
          >
            <van-field
              class="inputBack"
              v-model="password"
              :type="showornot"
              name="密码"
              placeholder="请输入密码"
              :rules="[{ required: true, message: '请填写密码' }]"
            >
              <template #button>
                <span @click="isShow">
                  <van-icon name="closed-eye" v-if="showeye" />
                  <van-icon name="eye-o" v-else />
                </span>
              </template>
            </van-field>
          </van-cell-group>
        </div>
        <div v-if="Switchlogin" class="qiehuandl">
          <div class="cutLogoType">
            <img
              class="cutLogoIcon"
              src="@/assets/icons/cutLogoType.png"
              alt=""
            />
            <div @click="Switchlogin = false">密码登录</div>
          </div>
        </div>
        <div v-else class="qiehuandl">
          <div class="cutLogoType">
            <img
              class="cutLogoIcon"
              src="@/assets/icons/cutLogoType.png"
              alt=""
            />
            <span @click="Switchlogin = true">验证码登录</span>
          </div>
          <p></p>
          <span class="span1" @click="wangjimimma">忘记密码</span>
        </div>
        <div class="xieyi">
          <van-checkbox
            v-model="checked"
            icon-size="16px"
            checked-color="#886DF3"
            >已阅读并同意<a
              href="http://static.aixunliu.com/app/user_agreement.html  "
              >《用户使用协议》</a
            >和<a href="http://static.aixunliu.com/app/privacy_policy.html "
              >《隐私政策》</a
            >内所有条款</van-checkbox
          >
        </div>
        <van-button
          type="info"
          class="btn"
          :disabled="
            (yanzhengma != '') & (phone != '') ||
            (password != '') & (phone != '')
              ? false
              : true
          "
          :color="
            checked & (yanzhengma != '') & (phone != '') ||
            checked & (password != '') & (phone != '')
              ? '#886DF3'
              : '#886DF3'
          "
          @click="mobiledenglu"
          >登录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getsendCode, mobileLogin, accountlogin } from "@/api/login";
import { setToken, setData } from "@/utils/auth";
import { mapState, mapMutations } from "vuex";
export default {
  name: "Login",

  data() {
    return {
      phone: "",
      yanzhengma: "",
      checked: false,
      yzm_daojishi: false,
      jiaodian: false,
      jiaodians: false,
      countDown: 60, // 倒计时时间
      timer: null, // 定时器
      password: "",
      showeye: true,
      showornot: "password",
      Switchlogin: true,
      showPopover: false,
      loginAccounts: [],
    };
  },
  mounted() {
    if (this.$route.query.code) {
      this.SET_CHANNELCODE(atob(this.$route.query.code));
    }
    this.loginAccounts =
      JSON.parse(localStorage.getItem("loginAccounts")) || [];
  },
  methods: {
    ...mapMutations("user", ["SET_TOKEN", "SET_DATA"]),
    fanhui() {
      this.$router.go(-1);
    },
    onSelect(action) {
      Toast(action.text);
    },
    zaixiankefu() {
      // this.$router.push("/clientServe");
    },
    huoqu() {
      this.jiaodian = true;
    },
    huoqus() {
      this.jiaodians = true;
    },
    shiqu() {
      this.jiaodian = false;
    },
    shiqus() {
      this.jiaodians = false;
    },
    // 获取验证码
    async getyanzhengma() {
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        Toast("手机号错误！请重新输入");
      } else {
        let data = {
          mobile: this.phone,
          businessType: "login",
        };
        await getsendCode(data).then((res) => {
          if (res.code == 200) {
            this.startCountDown();
            Toast("验证码已发送至您的手机");
          }
        });
      }
    },
    // 登录
    async mobiledenglu() {
      let that = this;
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        Toast("手机号错误！请重新输入");
      } else {
        if (!this.checked) {
          Toast("请你同意并阅读用户协议和隐私政策");
          return;
        }
        if (this.Switchlogin) {
          let data = {
            mobile: this.phone,
            code: this.yanzhengma,
          };
          await mobileLogin(data).then((res) => {
            if (res.code == 200) {
              res.data.loginType = "0";
              setToken(res.data.token);
              setData(res.data);
              that.SET_TOKEN(res.data.token);
              that.SET_DATA(JSON.stringify(res.data));
              that.addRecordPhone(res.data.phoneNumber);
              if (res.data.isRegister == 0) {
                this.$router.push({
                  path: "/setPassword",
                  query: {
                    phone: this.phone,
                    title: "设置密码",
                    skip: 1,
                  },
                });
              } else {
                this.getRegWelfare();
              }
            } else {
              Toast(res.msg);
            }
          });
        } else {
          let data = {
            phoneNumber: this.phone,
            password: this.password,
          };
          await accountlogin(data).then((res) => {
            if (res.code == 200) {
              res.data.loginType = "0";
              setToken(res.data.token);
              setData(res.data);
              that.SET_TOKEN(res.data.token);
              that.SET_DATA(JSON.stringify(res.data));
              that.addRecordPhone(res.data.phoneNumber);
              that.getRegWelfare();
            } else {
              Toast(res.msg);
            }
          });
        }
      }
    },
    getRegWelfare() {
      this.$router.push({
        name: "home",
      });
    },
    // 验证码倒计时
    startCountDown() {
      this.yzm_daojishi = true;
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(this.timer);
          this.yzm_daojishi = false;
          this.countDown = 60;
        }
      }, 1000);
    },
    //密码可见
    isShow() {
      //点击切换眼睛
      this.showeye = !this.showeye;
      if (this.showeye === true) {
        this.showornot = "password";
      } else {
        this.showornot = "text";
      }
    },
    // 忘记密码跳转
    wangjimimma() {
      this.$router.push("/forgotPassword");
    },
    addRecordPhone(phoneNumber) {
      let recordBool = true;
      this.loginAccounts.forEach((item) => {
        if (item == phoneNumber) {
          recordBool = false;
        }
      });
      if (recordBool) {
        if (this.loginAccounts.length >= 5) {
          this.loginAccounts.pop();
          this.loginAccounts.unshift(phoneNumber);
        } else {
          this.loginAccounts.unshift(phoneNumber);
        }
      }
      localStorage.setItem("loginAccounts", JSON.stringify(this.loginAccounts));
    },
    recordClick(item) {
      this.phone = item;
      this.showPopover = false;
    },
    delrecordClick(index) {
      this.loginAccounts.splice(index, 1);
      localStorage.setItem("loginAccounts", JSON.stringify(this.loginAccounts));
    },
    
  },
};
</script>
<style lang="less" scoped>
.inputBoxName {
  color: #333;
  font-size: 16px;
  font-weight: 700;
}
.overlayName {
  .wrapper {
    width: 100%;
    height: 100%;
    background: #fff;
    img {
      width: 100%;
      // height: 100%;
    }
  }
}
.login {
  height: 100%;
  background: #fff;
}
.headBox {
  background: linear-gradient(180deg, #e4e0ff, #fff);
  height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .logoClass {
    width: 100px;
    height: 100px;
  }
  .fanhuiBox {
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    .fanhui {
      width: 17px;
      height: 17px;
    }
  }
}

.main {
  text-align: left;
  padding: 0px 24px 0;
  margin-top: -12px;
  position: relative;
  .denglu {
    /deep/ .van-hairline--top-bottom::after {
      border: none;
    }
    .shoujihao {
      font-size: 16px;
      margin-bottom: 16px;
    }
    .yanzhengma {
      // height: 72px;
      font-size: 16px;
      margin-bottom: 16px;
      .yzm_btn {
        border: none;
        background: #f4f4f4;
        font-size: 14px;
        color: #886df3;
      }
      /deep/.van-field__body {
        height: 33px;
      }
    }
    .qiehuandl {
      display: flex;
      align-items: center;
      height: 32px;
      margin-top: -10px;
      .cutLogoType {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #999;
        margin-top: 5px;
        .cutLogoIcon {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }
      }
      p {
        flex: 1;
      }
      .span1 {
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #886df3;
        line-height: 20px;
      }
    }
    .inputBox {
      background-color: #f4f4f4;
      border-radius: 79px;
      overflow: hidden;
      margin-top: 10px;
      height: 48px;
      display: flex;
      align-items: center;
      .inputBack {
        background-color: #f4f4f4;
      }
    }
  }
  .shiqujiaodian {
    // border-bottom: 1px solid #f4f5f9;
  }
  .huoqujiaodian {
    // border-bottom: 1px solid #558bff;
  }
}
.btn {
  margin-top: 16px;
  width: 100%;
  border-radius: 22px;
  span {
    font-size: 16px !important;
  }
}
.xieyi {
  font-size: 10px;
  margin: 16px 0 auto;
  color: #999;
  a {
    color: #886df3;
  }
}
/deep/ .van-checkbox__label {
  font-size: 10px;
}

.cellGroup {
  width: 200px;
  .vanCell {
    display: flex;
    align-items: center;
    padding: 5px 10px;
  }
}
</style>